import { FormGroup, Validators } from '@angular/forms';

import { EventValidationAction } from './event-validation-action.enum';
import { FieldValidatorsMap, FormValidatorsMap } from '../interfaces';

import { ObjectLike } from 'app/interfaces';
import { FormModel } from 'app/models';

export class EventRules extends FormModel<EventValidationAction> {
    baseValidators: FieldValidatorsMap = {
        category: [Validators.required],
        description: [Validators.maxLength(255)],
        endAt: [],
        info: [],
        location: [],
        city: [],
        country: [Validators.required],
        maxRegistrations: [Validators.min(0)],
        name: [Validators.required],
        startAt: [Validators.required],
        vat: [Validators.required, Validators.min(0), Validators.max(100)],
    };
    formValidators: FormValidatorsMap = {};

    getStoreForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventValidationAction.Store, formFrom);
    }

    getStoreSubeventForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventValidationAction.StoreSubevent, formFrom);
    }

    getUpdateForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventValidationAction.Update, formFrom);
    }

    getUpdateSubeventForm(formFrom: ObjectLike = {}): FormGroup {
        return this.createFormGroup(EventValidationAction.UpdateSubevent, formFrom);
    }
}
